import React from 'react';
import PropTypes from 'prop-types';

import { datastoreComponentConnect } from './DatastoreComponentMixin.jsx';
import { READ, WRITE, SWITCHON, SWITCHOFF } from '../Om7Sense';
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
class PowerSwitchRow extends React.Component {

    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired,
        basePath: PropTypes.string
    }

    state = {
        "unlocked": false,
        hovering: 0,
        readOnly: false
    };

    handleClick = (event) => {
        this.togglePath(this.props.dataPath);
        event.preventDefault();
        event.stopPropagation();
    }

    togglePath = (relativePath) => {
        let _valData, _value;
        _value = this.context.p.getPath(this.props.basePath + relativePath);
        // TODO: Check first if we have a 'new' value and invert that
        if (_value.v !== undefined) {
            if (_value.v === "TRUE") {
                _valData = true;
            } else if (_value.v === "FALSE") {
                _valData = false;
            } else {
                _valData = _value.v;
            }
        } else {
            _valData = _value;
        }

        this.context.p.put(this.props.basePath + relativePath, ~~_valData ? 0 : 1);
        this.setState({ unlocked: false });
    }

    handleUnlock = (event) => {
        if (this.props.unlockPath) {
            this.togglePath(this.props.unlockPath);
        }
        this.setState({"unlocked": true});
        event.preventDefault();
        event.stopPropagation();
    }

    render() {
        const self = this;
        let value = this.props.data;

        let disabled = this.props.readOnlyUpstream, checked = false, checkedIsMixed = false;
        if (value && this.props.data.v !== undefined) {
            // Disable if data is being stored right now
            disabled = disabled | ~~value['new'];
            if (value['new'] !== null) {
                checked = ~~value['new'];
            } else {
                checkedIsMixed = value.v === "MIXED";
                checked = value.v === "TRUE" || ~~value.v || checkedIsMixed;
            }
        }

        if (this.props.invertState) {
            checked = ~checked;
        }

        const path = this.props.basePath + this.props.dataPath;

        if (!disabled) {
            // First, check for full write permission
            if (!this.context.p.checkPermission(WRITE, path)) {
                // No, but maybe it's switched on and user can switch it off?
                if (checked) {
                    if (!this.context.p.checkPermission(SWITCHOFF, path)) {
                        // Can't switch it off
                        disabled = true;
                    }
                } else {
                    // No, it's off - can he switch it on?
                    if (!this.context.p.checkPermission(SWITCHON, path)) {
                        // No, disable
                        disabled = true;
                    }
                }
            }
        }

        function hoverOn() {
            self.setState((state) => {
                return {
                    hovering: state.hovering + 1
                };
            });
        }

        function hoverOff() {
            self.setState((state) => {
                // console.log("hoverOff: ", state.hovering - 1);
                return {
                    hovering: state.hovering - 1,
                    unlocked: state.unlocked && state.hovering > 1
                };
            });
        }

        const t = this.context.t;
        let className = disabled ? "disabled" : "enabled";
        
        if (checked) {
            if (checkedIsMixed) {
                className += " powermixed";
            } else {
                className += " poweron";
            }
        } else {
            className += " poweroff";
        }

        const titleText = this.props.titleText || t("details_configuration." + (this.props.isInDC ? "title_switch_rackdevice" : "title_switch_outlet"));
        const buttonText = this.props.buttonText || t("details_configuration." + (this.props.isInDC ? "button_change_rackdevice_power" : "button_change_outlet_power"));
        const powerOnText = this.props.powerOnText || t("details_configuration.power_on");
        const powerOffText = this.props.powerOffText || t("details_configuration.power_off");

        return (
            <div className="switch" onMouseLeave={hoverOff} onMouseEnter={hoverOn}>
                <div className={ className } onClick={ !disabled ? this.handleUnlock : null} >
                    <FontAwesomeIcon icon={icon({name: 'power-off', family: 'sharp', style: 'solid'})} />
                </div>

                { this.state.unlocked && (
                    <div className="popoverClass" onMouseLeave={hoverOff} onMouseEnter={hoverOn}>
                        <div className="card">
                            <div className="card-header">
                                <div className="card-title h5">
                                    { titleText }
                                </div>
                            </div>
                            <div className="card-body">
                                <p>
                                    { buttonText }
                                    <br />
                                    <span>{t("details_configuration.please_use_with_care")}</span>
                                </p>
                                <div className="form-group">
                                    <div className="col-12 col-sm-12">
                                        <label className="form-radio">
                                            <input type="radio" checked={checked && !checkedIsMixed} onChange={self.handleClick} />
                                            <i className="form-icon"></i>
                                            <span className="on">{ powerOnText }</span>
                                        </label>
                                        <label className="form-radio">
                                            <input type="radio" checked={!checked} onChange={self.handleClick} />
                                            <i className="form-icon"></i>
                                            <span className="off">{ powerOffText }</span>
                                    </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                  )}

            </div>
        );
    }
}

PowerSwitchRow.defaultProps = {
    "resetTimer": 10000
};

export default datastoreComponentConnect(PowerSwitchRow);

